/** Compatibility export; the headless package owns this contract. */
export * from '@galapagos/catalog-schema/components/Icon/Icon';
export { iconDefs } from '../../elements/icons';
export type { IconPathDef, IconDef } from '../../elements/icons';
